import React from 'react';
import { PageHeader } from '../components/shared/PageHeader';
import { ContactForm } from '../components/shared/ContactForm';
import { ContactInfo } from '../components/shared/ContactInfo';
import { useLanguage } from '../contexts/LanguageContext';
import { useSeo } from '../hooks/useSeo';
export function Contact() {
  const {
    t,
    lang
  } = useLanguage();
  const c = t.contact;
  useSeo({
    ...t.common.seo.contact,
    lang
  });
  return <main data-id="element-450" data-mp="y1gz153j4zwp">
      <PageHeader eyebrow={c.eyebrow} title={c.title} description={c.description} data-id="element-451" data-mp="y0yxbsy3lthe" />
      <section className="bg-white py-14 sm:py-20" data-id="element-452" data-mp="t2xbj09afg28">
        <div className="mx-auto grid max-w-7xl gap-10 px-5 sm:px-8 lg:grid-cols-12 lg:gap-12" data-id="element-453" data-mp="17q8p17p15a4z">
          <div className="lg:col-span-7" data-id="element-454" data-mp="12zs8hepwx8ee">
            <ContactForm data-id="element-455" data-mp="12z0fmbnp9ort" />
          </div>
          <div className="lg:col-span-5" data-id="element-456" data-mp="12xxn5zaqbe9s">
            <ContactInfo data-id="element-457" data-mp="f9ekbzag7tp3" />
          </div>
        </div>
      </section>
    </main>;
}